// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-container {
  max-width: 215px;
}
.slide-container .product-image-container {
  position: relative;
  cursor: pointer;
}
.slide-container .product-image-container .poduct-image-div {
  display: flex;
  flex: 100%;
  overflow: hidden;
}
.slide-container .product-image-container .poduct-image-div img {
  width: 224px;
  height: 224px;
  object-fit: contain;
  cursor: not-allowed;
}
.slide-container .product-image-container .product-image {
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
}
.slide-container .product-image-container .product-discount {
  position: absolute;
  top: 0.75rem;
  left: -10px;
  background: var(--ion-orange-primary);
  padding: 0 0.4375rem;
  height: 1.625rem;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5625rem;
}
.slide-container .product-image-container .product-fav {
  position: absolute;
  right: 0.625rem;
  top: 0.625rem;
  cursor: pointer;
}
.slide-container .product-image-container .product-fav ion-icon {
  width: 1.875rem;
  height: 1.875rem;
}
.slide-container .product-image-container .product-outofstock {
  position: absolute;
  top: 39%;
  left: 28%;
}
.slide-container .product-image-container .product-outofstock .outofstock-label {
  color: var(--ion-color-medium-contrast);
  font-weight: bold;
  font-size: 0.875rem;
  background: var(--ion-black-primary);
  padding: 0.4375rem;
}
.slide-container .product-description {
  color: var(--ion-black-primary);
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 1.375rem;
  padding-top: 1.375rem;
}
.slide-container .product-brand {
  color: var(--ion-grey1);
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  padding-top: 0.5rem;
}
.slide-container .product-price .from {
  color: var(--ion-grey1);
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
  padding-top: 0.8125rem;
}
.slide-container .product-price .product-price-data .currency,
.slide-container .product-price .product-price-data .price {
  color: var(--ion-black-primary);
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.5625rem;
}
.slide-container .product-price .product-price-data .unit {
  color: var(--ion-black-primary);
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5625rem;
}

.action-block {
  display: flex;
  justify-content: space-between;
  margin-top: 1.0625rem;
}
.action-block .left-block img {
  width: 0.875rem;
  cursor: pointer;
}
.action-block .left-block .edit {
  margin-right: 1.25rem;
}
.action-block .right-block span {
  font-weight: 600;
  color: var(--ion-app-primary);
  font-size: 0.87em;
  cursor: pointer;
}

@media screen and (max-width: 500px) {
  .product-image-container img {
    width: 150px !important;
  }
}
@media screen and (max-width: 1200px) {
  .slide-container .product-image-container img {
    min-width: 125px !important;
  }
}
@media screen and (max-width: 1400px) {
  .action-block .left-block .edit {
    margin-right: 0.5rem;
  }
  .slide-container .product-image-container img {
    min-width: 130px;
  }
}
.detail-slide-container {
  max-width: 224px !important;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-card/product-card.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,kBAAA;EACA,eAAA;AACR;AACQ;EACI,aAAA;EACA,UAAA;EACA,gBAAA;AACZ;AAAY;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAEhB;AAGQ;EAEI,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EAEA,qCAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAJZ;AAMY;EACI,eAAA;EACA,gBAAA;AAJhB;AAQQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AANZ;AAQY;EACI,uCAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;AANhB;AAWI;EACI,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AATR;AAYI;EACI,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AAVR;AAcQ;EACI,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;AAZZ;AAiBY;;EAEI,+BAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAfhB;AAkBY;EACI,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAhBhB;;AAsBA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;AAnBJ;AAsBQ;EACI,eAAA;EACA,eAAA;AApBZ;AAuBQ;EACI,qBAAA;AArBZ;AA0BQ;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAxBZ;;AA6BA;EAEQ;IACI,uBAAA;EA3BV;AACF;AAgCA;EAGY;IACI,2BAAA;EAhCd;AACF;AAqCA;EAGY;IACI,oBAAA;EArCd;EA4CU;IACI,gBAAA;EA1Cd;AACF;AAgDA;EACI,2BAAA;EACA,mBAAA;AA9CJ","sourcesContent":[".slide-container {\n    max-width: 215px;\n\n    .product-image-container {\n        position: relative;\n        cursor: pointer;\n\n        .poduct-image-div {\n            display: flex;\n            flex: 100%;\n            overflow: hidden;\n            img{\n                width: 224px;\n                height: 224px;\n                object-fit: contain;\n                cursor: not-allowed;\n                \n            }\n        }\n\n        .product-image {\n            -webkit-filter: blur(5px);\n            -moz-filter: blur(5px);\n            -o-filter: blur(5px);\n            -ms-filter: blur(5px);\n            filter: blur(5px);\n        }\n\n        .product-discount {\n            position: absolute;\n            top: 0.75rem;\n            left: -10px;\n            // background-image: url(\"/assets/icon/discount-rectangle.svg\");\n            background: var(--ion-orange-primary);\n            padding: 0 0.4375rem;\n            height: 1.625rem;\n            color: #FFFFFF;\n            font-weight: 600;\n            font-size: 0.875rem;\n            line-height: 1.5625rem;\n        }\n\n        .product-fav {\n            position: absolute;\n            right: 0.625rem;\n            top: 0.625rem;\n            cursor: pointer;\n\n            ion-icon {\n                width: 1.875rem;\n                height: 1.875rem;\n            }\n        }\n\n        .product-outofstock {\n            position: absolute;\n            top: 39%;\n            left: 28%;\n\n            .outofstock-label {\n                color: var(--ion-color-medium-contrast);\n                font-weight: bold;\n                font-size: 0.875rem;\n                background: var(--ion-black-primary);\n                padding: 0.4375rem;\n            }\n        }\n    }\n\n    .product-description {\n        color: var(--ion-black-primary);\n        font-weight: bold;\n        font-size: 1.125rem;\n        line-height: 1.375rem;\n        padding-top: 1.375rem;\n    }\n\n    .product-brand {\n        color: var(--ion-grey1);\n        font-weight: 500;\n        font-size: 0.9375rem;\n        line-height: 1.125rem;\n        padding-top: 0.5rem;\n    }\n\n    .product-price {\n        .from {\n            color: var(--ion-grey1);\n            font-weight: 400;\n            font-size: 0.75rem;\n            line-height: 1.125rem;\n            padding-top: 0.8125rem;\n        }\n\n        .product-price-data {\n\n            .currency,\n            .price {\n                color: var(--ion-black-primary);\n                font-weight: 700;\n                font-size: 1.2rem;\n                line-height: 1.5625rem;\n            }\n\n            .unit {\n                color: var(--ion-black-primary);\n                font-weight: 400;\n                font-size: 0.875rem;\n                line-height: 1.5625rem;\n            }\n        }\n    }\n}\n\n.action-block {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 1.0625rem;\n\n    .left-block {\n        img {\n            width: 0.875rem;\n            cursor: pointer;\n        }\n\n        .edit {\n            margin-right: 1.25rem;\n        }\n    }\n\n    .right-block {\n        span {\n            font-weight: 600;\n            color: var(--ion-app-primary);\n            font-size: .87em;\n            cursor: pointer;\n        }\n    }\n}\n\n@media screen and (max-width: 500px) {\n    .product-image-container {\n        img {\n            width: 150px !important;\n        }\n    }\n\n}\n\n@media screen and (max-width: 1200px) {\n    .slide-container {\n        .product-image-container {\n            img {\n                min-width: 125px !important;\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 1400px) {\n    .action-block {\n        .left-block {\n            .edit {\n                margin-right: 0.5rem;\n            }\n        }\n    }\n\n    .slide-container {\n        .product-image-container {\n            img {\n                min-width: 130px;\n            }\n        }\n    }\n}\n\n\n.detail-slide-container {\n    max-width: 224px !important;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
